import React from 'react';

import ImageTextOverlay from '@common/ImageTextOverlay';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y } from 'swiper/modules';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';


const FlexMobileLinks = ({ data }) => {
  const { links } = data;
  return (
    <Swiper className='mt-3 d-lg-none'
      modules={[A11y]}
      slidesPerView={links.length > 1 ? 1.3 : 1}
      spaceBetween={20}
      >
      {links.map((link, index) => (
        <SwiperSlide key={index}>
          <ImageTextOverlay to={link.link} image={link.image} colour={link.bgColour}>
            <div className='fs-18 fw-medium' style={{marginBottom:'15px'}}>{link.title}</div>
            <div className='d-flex align-items-center fs-16 fw-normal'>
              <span style={{marginRight: '5px'}}>{link.linkCopy}</span>
              <FontAwesomeIcon icon={faChevronRight} size ='sm'/>
            </div>
          </ImageTextOverlay>
        </SwiperSlide>
      ))}
    </Swiper>
  )
}

export default FlexMobileLinks
